var addListExpandHandler = function() {
  $('body').on('click', '.a-list *[data-toggle="collapse"]', function() {
    // This script runs before the bootstrap collapse handler, so the collapsed-class will still be
    // present even though the content is about to be expanded
    if ($(this).hasClass('collapsed')) {
      $(this).closest('li').addClass('a-expanded');
      $(this).closest('li').siblings().removeClass('a-expanded');
    } else {
      $(this).closest('li').removeClass('a-expanded');
    }
  });
};
